import Index from "../components/Logo/index";

const Logo = () => {
    return <Index />;
};

export default Logo;
